var _path, _g, _g2, _rect, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdcwxg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2246_5401)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2246_5401",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.37271 0 0 5.37237 0 11.9999C0 18.6271 5.37271 24 12.0001 24C18.6274 24 24 18.6271 24 11.9999C24 5.37237 18.6273 0 12.0001 0Z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2246_5401)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2246_5401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.65 24 24 18.65 24 12C24 5.34996 18.65 0 12 0C5.34996 0 0 5.34996 0 12C0 18.65 5.34996 24 12 24Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00101 9.54992C3.55094 13.4 5.55097 17.75 9.45097 19.1499C9.60097 19.25 9.75097 19.4499 9.75097 19.5999V20.3C9.75097 20.4 9.75097 20.45 9.70093 20.4999C9.65101 20.7 9.45097 20.7999 9.25093 20.7C6.45097 19.8 4.30093 17.6499 3.40093 14.85C1.90093 10.1 4.50098 5.04992 9.25093 3.54992C9.30097 3.5 9.40093 3.5 9.45097 3.5C9.65101 3.54992 9.75097 3.69992 9.75097 3.89996V4.59992C9.75097 4.85 9.65101 5 9.45097 5.09996C7.40101 5.84996 5.75101 7.44992 5.00101 9.54992ZM14.301 3.74996C14.3509 3.54992 14.551 3.44996 14.751 3.54992C17.5009 4.44992 19.701 6.59996 20.601 9.44996C22.101 14.1999 19.501 19.25 14.751 20.75C14.701 20.7999 14.601 20.7999 14.551 20.7999C14.3509 20.75 14.251 20.6 14.251 20.4V19.7C14.251 19.4499 14.3509 19.2999 14.551 19.2C16.6009 18.45 18.2509 16.85 19.0009 14.75C20.451 10.8999 18.451 6.54992 14.551 5.15C14.401 5.04992 14.251 4.85 14.251 4.64996V3.95C14.251 3.84992 14.251 3.8 14.301 3.74996ZM12.1515 11.2997C14.2515 11.5497 15.3015 12.1497 15.3015 13.8996C15.3015 15.2496 14.3015 16.2996 12.8015 16.5497V17.7497C12.7515 17.9997 12.6015 18.1497 12.4015 18.1497H11.6515C11.4015 18.0996 11.2515 17.9496 11.2515 17.7497V16.5497C9.60152 16.2996 8.80148 15.3996 8.60156 14.1497V14.0997C8.60156 13.8996 8.75156 13.7496 8.95148 13.7496H9.80155C9.95155 13.7496 10.1016 13.8497 10.1515 14.0496C10.3015 14.7996 10.7515 15.3497 12.0515 15.3497C13.0015 15.3497 13.7015 14.7997 13.7015 13.9997C13.7015 13.1997 13.2515 12.8997 11.8515 12.6497C9.75151 12.3996 8.75156 11.7497 8.75156 10.0997C8.75156 8.84966 9.70148 7.84969 11.2015 7.64965V6.49969C11.2515 6.24961 11.4015 6.09961 11.6015 6.09961H12.3515C12.6015 6.14965 12.7515 6.29965 12.7515 6.49969V7.69969C13.9014 7.79965 14.8014 8.64961 15.0015 9.74966V9.7997C15.0015 9.99962 14.8515 10.1496 14.6514 10.1496H13.8515C13.7015 10.1496 13.5515 10.0497 13.5015 9.89966C13.2515 9.14966 12.7515 8.84966 11.8515 8.84966C10.8515 8.84966 10.3515 9.29954 10.3515 9.99962C10.3515 10.6997 10.6515 11.0997 12.1515 11.2997Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: -3,
    y: 14,
    width: 29,
    height: 7,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0223 20H9.78985V19.5455H9.55737V19.0909H9.32488V18.6364H9.09239V18.1818H8.8599V17.7273H8.62741V17.2727H8.39493V17.7273H8.16244V18.1818H7.92995V18.6364H7.69746V19.0909H7.46498V19.5455H7.23249V20H7V15H7.69746V17.5H7.92995V17.0455H8.16244V16.5909H8.39493V16.1364H8.62741V16.5909H8.8599V17.0455H9.09239V17.5H9.32488V15H10.0223V20Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5112 20H12.8137V19.3182H12.5812V18.6364H12.3487V18.1818H12.1162V17.9545H11.8838V18.1818H11.6513V18.6364H11.4188V19.3182H11.1863V20H10.4888V19.3182H10.7213V18.6364H10.9538V18.1818H11.1863V17.7273H11.4188V17.2727H11.1863V16.8182H10.9538V16.3636H10.7213V15.6818H10.4888V15H11.1863V15.6818H11.4188V16.3636H11.6513V16.8182H11.8838V17.0455H12.1162V16.8182H12.3487V16.3636H12.5812V15.6818H12.8137V15H13.5112V15.6818H13.2787V16.3636H13.0462V16.8182H12.8137V17.2727H12.5812V17.7273H12.8137V18.1818H13.0462V18.6364H13.2787V19.3182H13.5112V20Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.5455H16.7675V19.7727H16.535V20H14.9076V19.7727H14.6751V19.5455H14.4426V19.3182H14.2101V19.0909H13.9777V15.9091H14.2101V15.6818H14.4426V15.4545H14.6751V15.2273H14.9076V15H16.535V15.2273H16.7675V15.4545H17V15.9091H16.3025V15.6818H15.1401V15.9091H14.9076V16.1364H14.6751V18.8636H14.9076V19.0909H15.1401V19.3182H16.3025V17.9545H16.07V18.1818H15.3726V17.2727H17V19.5455Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2246_5401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2246_5401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdcwxg);
export default __webpack_public_path__ + "static/media/USDCWXG.2d4a42bbdfa716d2112683b838f186f5.svg";
export { ForwardRef as ReactComponent };